import { Pagination, PaginationItem, PaginationLink } from "reactstrap"

const PaginationComponent = () => {
  return (
    <>
      <Pagination
        aria-label="Page navigation example"
        className=" "
        style={{ float: "right" }}
        size="md"
      >
        <PaginationItem className=" x-2">
          <PaginationLink href="/" previous className="py-1 px-5">
            Previous
          </PaginationLink>
        </PaginationItem>
        <PaginationItem>
          <PaginationLink href="/" className="bg-primary text-light py-1 px-3">
            1
          </PaginationLink>
        </PaginationItem>
        <PaginationItem>
          <PaginationLink href="/" className="py-1 px-3">
            2
          </PaginationLink>
        </PaginationItem>
        <PaginationItem>
          <PaginationLink href="/" className="py-1 px-3">
            3
          </PaginationLink>
        </PaginationItem>
        <PaginationItem>
          <PaginationLink href="/" className="py-1 px-3">
            4
          </PaginationLink>
        </PaginationItem>
        <PaginationItem>
          <PaginationLink href="/" className="py-1 px-3">
            5
          </PaginationLink>
        </PaginationItem>
        <PaginationItem>
          <PaginationLink href="/" className="py-1 px-3">
            6
          </PaginationLink>
        </PaginationItem>
        <PaginationItem>
          <PaginationLink href="/" next className="px-5 py-1">
            Next
          </PaginationLink>
        </PaginationItem>
      </Pagination>
    </>
  )
}

export default PaginationComponent
